import EditBase from "./EditBase"

class EditBillboard extends EditBase {
    constructor(options) {
        super(options);
        this.styleOrig = undefined;
        this.styleEdit = {
            scale: 1.1
        };
    }
    mouseMove(evt) {
        let pick = this.viewer.scene.pick(evt.endPosition);
        var entity = this.getPickEnity(pick);
        if (this.styleOrig) {
            this.setStyle(this.plot.billboard, this.styleOrig);
        }
        if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
            this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
            if (!this.styleOrig) {
                this.styleOrig = this.getStyle(entity.billboard, this.styleEdit);
            }
            this.setStyle(entity.billboard, this.styleEdit);
        }
        if (this.pick) {
            this.setStyle(this.pick.billboard, this.styleEdit);
            var cartesian = this.getCatesian3FromPX(evt.endPosition);
            this.pick.position.setValue(cartesian);
        }
    }
    leftDown(evt) {
        if (this.styleOrig) {
            this.setStyle(this.plot.billboard, this.styleOrig);
        }

        let pick = this.viewer.scene.pick(evt.position);
        var entity = this.getPickEnity(pick);
        if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
            this.pick = entity;
            this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
            this.callback && this.callback(this.pick);
        }
    }

    leftUp(evt) {
        this.pick = null;
        this.viewer.scene.screenSpaceCameraController.enableRotate = true;//解锁相机
    }

}

export default EditBillboard;